<template>
  <div
    class="absolute_center"
    style="width: 1620px;"
    :class="{
      _boxBg_green_secondLevel: styleType == 'typeGreen',
      _boxBg_dark_secondLevel: styleType == 'typeDark',
      _boxBg_blue_secondLevel: styleType == 'typeBlue',
      _boxBg_strong_secondLevel: styleType == 'typeStrong',
    }"
  >
    <div class="selfClose_btn" @click="close"></div>
    <div class="account" v-if="type !== 'nonMovement'" style="overflow-y: scroll">
      <div class="basic-info">
        <div class="basic-item" v-if="newAccessType">
          <label class="item-label">环保登记编码：</label>
          <span>{{info&&info.numberPlate}}</span>
        </div>
        <div class="basic-item">
          <label class="item-label">车牌号码：</label>
          <span>{{ info?.numberPlate }}</span>
        </div>
        <div class="basic-item">
          <label class="item-label">发动机号码：</label>
          <span>{{ info?.engineNumber }}</span>
        </div>
        <div class="basic-item">
          <label class="item-label">车辆识别代号(VIN)：</label>
          <span>{{ info?.vin }}</span>
        </div>
        <div class="basic-item">
          <label class="item-label">车队名称：</label>
          <span>所有人</span>
        </div>
        <div class="basic-item">
          <label class="item-label">注册日期：</label>
          <span>{{ info?.registrationDate }}</span>
        </div>
        <div class="basic-item">
          <label class="item-label">生产日期：</label>
          <span>{{ info?.productionDate }}</span>
        </div>
        <div class="basic-item">
          <label class="item-label">排放阶段：</label>
          <span>{{ vehicleMissionsName[info?.vehicleEmissions] ?? "" }}</span>
        </div>
        <div class="basic-item">
          <label class="item-label">燃料类型：</label>
          <span>{{ info?.fuelType }}</span>
        </div>
        <div class="basic-item" v-if="newAccessType">
          <label class="item-label">所属单位：</label>
          <span>{{info && info.owener}}</span>
        </div>
        <div class="basic-item" v-if="newAccessType">
          <label class="item-label">车辆类型：</label>
          <span>{{info && info.vehicleType}}</span>
        </div>
        <div class="basic-item" v-if="newAccessType">
          <label class="item-label">车辆品牌型号：</label>
          <span>{{info && info.model}}</span>
        </div>
        <div class="basic-item">
          <label class="item-label">联网状态：</label>
          <span>{{info && (info.onlineStatus == 1 ? '已联网' : info.onlineStatus == 2 ? '未联网' : '未知') }}</span>
        </div>
      </div>
      <div class="picture-info">
        <div class="picture-inner" @click="picture_click(info?.drivingLicense)">
          <div class="picture">
            <img
              v-if="info && info.drivingLicense"
              :src="info?.drivingLicense"
            />
            <img v-else src="./img/no_img.png" />
            <span>行驶证</span>
          </div>
        </div>
        <div class="picture-inner" @click="picture_click(info?.onBoardList)">
          <div class="picture">
            <img v-if="info && info.onBoardList" :src="info?.onBoardList" />
            <img v-else src="./img/no_img.png" />
            <span>随车清单</span>
          </div>
        </div>
        <div class="picture-inner" v-if="newAccessType && customerId != 50" @click="picture_click(info.vehicleImage)">
          <div class="picture">
            <img v-if="info.vehicleImage" :src="info&&info.vehicleImage" />
            <img v-else src="./img/no_img.png" />
            <span>车辆照片</span>
          </div>
        </div>
        <div class="picture-inner" v-if="newAccessType && customerId != 50" @click="picture_click(info.engineImage)">
          <div class="picture">
            <img v-if="info.engineImage" :src="info&&info.engineImage" />
            <img v-else src="./img/no_img.png" />
            <span>车身铭牌</span>
          </div>
        </div>
        <div class="picture-inner" v-if="newAccessType && customerId != 50" @click="picture_click(info.vinVerificationImg)">
          <div class="picture">
            <img v-if="info.vinVerificationImg" :src="info&&info.vinVerificationImg" />
            <img v-else src="./img/no_img.png" />
            <span>机动车环保网查询图片</span>
          </div>
        </div>
        <div class="picture-inner" v-if="newAccessType && customerId != 50" @click="picture_click(info.vehicleLicenseVerificationImg)">
          <div class="picture">
            <img v-if="info.vehicleLicenseVerificationImg" :src="info&&info.vehicleLicenseVerificationImg" />
            <img v-else src="./img/no_img.png" />
            <span>重型柴油车排放阶段查询图片</span>
          </div>
        </div>
      </div>
    </div>
    <div class="account" v-else style="overflow-y: scroll">
      <div class="basic-info">
        <div class="basic-item">
          <label class="item-label">环保登记编码：</label>
          <span>{{ info?.environmentCode }}</span>
        </div>
        <div class="basic-item" v-if="newAccessType">
          <label class="item-label">环保信息公开编码：</label>
          <span>{{info?.environmentSn}}</span>
        </div>
        <div class="basic-item" v-if="newAccessType">
          <label class="item-label">所属单位：</label>
          <span>{{ info?.owener }}</span>
        </div>
        <div class="basic-item" v-else>
          <label class="item-label">车队名称：</label>
          <span>所有人</span>
        </div>
        <div class="basic-item">
          <label class="item-label">生产日期：</label>
          <span>{{ info?.productionDate }}</span>
        </div>
        <div class="basic-item">
          <label class="item-label">排放阶段：</label>
          <span>{{ vehicleMissionsName[info?.vehicleEmissions] ?? "" }}</span>
        </div>
        <div class="basic-item" >
          <label class="item-label">机械型号：</label>
          <span>{{ info?.mechanicalModel }}</span>
        </div>
         <div class="basic-item" v-if="customerId == 22 || newAccessType">
          <label class="item-label">机械种类：</label>
          <span>{{ info?.machineType }}</span>
        </div>
        <div class="basic-item">
          <label class="item-label">{{
            customerId != 22
              ? "机械环保代码："
              : "机械环保代码\环保信息公开编码："
          }}</label>
          <span>{{ info?.mechanicalEnvironment }}</span>
        </div>
        <!-- <div class="basic-item" v-if="customerId==22">
          <label class="item-label">环保信息公开编码：</label>
          <span>{{info?.openCode}}</span>
        </div> -->
        <div class="basic-item" v-if="newAccessType">
          <label class="item-label">发动机型号：</label>
          <span>{{ info?.engineType }}</span>
        </div>
        <div class="basic-item" v-if="newAccessType">
          <label class="item-label">发动编号：</label>
          <span>{{ info?.engineModel }}</span>
        </div>
        <div class="basic-item">
          <label class="item-label">发动机生产厂：</label>
          <span>{{ info?.engineVendor }}</span>
        </div>
        <div class="basic-item" v-if="customerId == 22 || newAccessType">
          <label class="item-label">燃料类型：</label>
          <span>{{ info?.fuelType }}</span>
        </div>
        <div class="basic-item" v-if="newAccessType">
          <label class="item-label">车牌号码：</label>
          <span>{{ info?.numberPlate }}</span>
        </div>
      </div>

      <div class="picture-info">
        <div class="picture-inner" v-if="newAccessType && customerId != 50" @click="picture_click(info.environmentLabelImage || info.vehicleLable)">
          <div class="picture">
            <img
              v-if="info && (info.environmentLabelImage)"
              :src="info && (info.environmentLabelImage)"
            />
            <img v-else src="./img/no_img.png" />
            <span>机械环保标签铭牌</span>
          </div>
        </div>
        <div class="picture-inner" @click="picture_click(info?.engineImage || info.engineNameplate)">
          <div class="picture">
            <img v-if="info?.engineImage || info.engineNameplate" :src="info?.engineImage  || info.engineNameplate" />
            <img v-else src="./img/no_img.png" />
            <span>发动机铭牌</span>
          </div>
        </div>
          <div class="picture-inner" @click="picture_click(info?.vehicleLable || info.vehicleLable)">
          <div class="picture">
            <img v-if="info?.vehicleLable || info.vehicleLable" :src="info?.vehicleLable  || info.vehicleLable" />
            <img v-else src="./img/no_img.png" />
            <span>环保信息标签图片</span>
          </div>
        </div>
        <div
          v-if="customerId == 22"
          class="picture-inner label-photo"
          @click="picture_click(info?.labelPhoto)"
        >
          <div class="picture">
            <img v-if="info?.labelPhoto" :src="info?.labelPhoto" />
            <img v-else src="./img/no_img.png" />
          </div>
        </div>
        <div
          v-if="(customerId == 59 || newAccessType || isShowEmissionSourceDataYaxis) && customerId !=50"
          class="picture-inner label-photo"
          @click="picture_click(info?.deviceImage || info.carNameplate)"
        >
          <div class="picture">
            <img v-if="info?.deviceImage  || info.carNameplate" :src="info?.deviceImage  || info.carNameplate" />
            <img v-else src="./img/no_img.png" />
            <span v-if="newAccessType">设备照片</span>
            <span v-else>{{customerId == 50 ? '整车铭牌' : isShowEmissionSourceDataYaxis ? "车身照片" :'设备铭牌'}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import imgBox from "./components/imgBox.vue";
export default {
  name: "accountBasic",
  title: "详细信息",
  props: ["globalInstance", "type", "number"],
  setup(props) {
    const type = props.type;
    const number = props.number;
    const globalInstance = props.globalInstance;
    return { globalInstance, type, number };
  },
  data() {
    return {
      newAccessType: this.$store.state.newAccessType,
      prefix: "",
      styleType: "",
      // type: "",
      // number: "",
      info: {},
      vehicleMissionsName: {
        1: '国I',
        2: '国II',
        3: "国III",
        4: "国IV",
        5: "国V",
        6: "国VI",
        99: "新能源",
        101: "铁路运输",
        102: "水路运输",
        103: "管道或管状带式输送机",
      },
      customerId: this.$store.state.customerId,
      isPublicCleanTransport: bmeConfig.isPublicCleanTransport,
      isShowEmissionSourceDataYaxis: bmeConfig.isShowEmissionSourceDataYaxis
    };
  },
  computed: {
    ...mapGetters({
      dialogCompontent2: "getDialogCompontent2",
    }),
  },
  mounted() {
    // this.type = this.$route.query.type;
    // this.number = this.$route.query.number;
    this.getData();
  },

  created() {
    this.styleType = this.globalInstance.$store.state.styleType;
  },
  watch: {
    number(newValue, oldValue) {
      this.getData();
    },
  },
  methods: {
    async getCarDetailInFactory() {
      let url = this.globalInstance.cleanTransportIp + "/in_factory/detail";
      let res;
      if (this.isPublicCleanTransport) {
        res = await this.$apiUtils.get3(url, {
          numberPlate: this.number,
          customerId: this.customerId,
        });
      } else {
        res = await this.globalInstance.$apiUtils.get3(url, {
          numberPlate: this.number,
          customerId: this.customerId,
        });
      }
      this.info = res;
    },
    async getCarDetailNonMovement() {
      let url = this.globalInstance.cleanTransportIp + "/no_road/detail";
      let res = await this.globalInstance.$apiUtils.get3(url, {
        environmentCode: this.number,
        customerId: this.customerId,
      });
      this.info = res;
    },
    getData() {
      switch (this.type) {
        case "factory":
          this.getCarDetailInFactory();
          break;
        case "nonMovement":
          this.getCarDetailNonMovement();
          break;
      }
    },
    picture_click(url) {
      if (!url) return;
      this.globalInstance.$store.commit("dialogStatus2", true);
      this.globalInstance.$popup.open2(imgBox, this.dialogCompontent2, this, {
        imgurl: url,
      });
    },
    close() {
      let that = this._.appContext.app;
      this.$popup.close(that);
    },
  },
};
</script>
<style lang="scss" scoped>
.account {
  width: 100%;
  height: 100%;
  padding: 70px 80px;
  font-size: 20px;
  .basic-info {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .basic-item {
      width: 33.3%;
      height: 60px;
      line-height: 30px;
      color: white;
      .item-label {
        color: #a2d8ff;
      }
    }
  }
  .picture-info {
    margin-top: 140px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .picture-inner {
      width: 49%;
      margin-bottom: 25px;
      p {
        color: #a2d8ff;
        font-size: 22px;
        line-height: 130px;
        text-align: center;
      }
      .picture {
        padding: 10px;
        width: 100%;
        height: 340px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        // background-image: url("../img/img_bg.png");
        position: relative;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img {
          width: 100%;
          height: 100%;
        }

        span {
          font-weight: bold;
          color: #d7d7d7;
          font-size: 24px;
        }
        &:before {
          content: "";
          position: absolute;
          top: 20px;
          right: 20px;
          width: 54px;
          height: 54px;
          // background-image: url("./../img/enlarge.png");
        }
      }
    }
    .label-photo {
      margin-left: 10px;
    }
  }
}
</style>
